const Metronome = ({ bpm, setBpm, onTick, stop = 0 }) => {
  const interval = 60000.0 / bpm
  const [isPlaying, setIsPlaying] = useState(false)
  const [volume, setVolume] = useState(0.2)
  const toogleIsPlaying = useCallback(() => {
    return setIsPlaying((currentIsPlaying) => {
      return !currentIsPlaying
    })
  })
  const soundRef = useRef(null)

  const onDown = useCallback(() => {
    return setBpm(bpm - 1)
  })

  const on10Down = useCallback(() => {
    return setBpm(bpm - 10)
  })

  const onUp = useCallback(() => {
    return setBpm(bpm + 1)
  })

  const on10Up = useCallback(() => {
    return setBpm(bpm + 10)
  })

  useEffect(() => {
    return setIsPlaying(false)
  }, [stop])

  // const sound = useMemo(() => {
  //   return new Audio('/audio/tick.mp3')
  // })

  useEffect(() => {
    soundRef.current = new Audio('/audio/tick.mp3')
    soundRef.current.volume = volume
    return () => {
      if (soundRef.current) {
        soundRef.current.pause()
        soundRef.current = null
      }
    }
  }, [])

  const tick = useCallback(() => {
    if (!isPlaying) return
    onTick && onTick()
    soundRef.current.play()
  }, [isPlaying])

  const onVolumeChange = useCallback(
    (e) => {
      const newVolume = parseFloat(e.target.value)
      setVolume(newVolume)
      soundRef.current.volume = newVolume
    },
    [soundRef.current]
  )

  useEffect(() => {
    const intervalId = setInterval(() => {
      tick()
    }, interval)

    // 2. Clean up the interval on component unmount
    return () => clearInterval(intervalId)
  }, [interval, tick])

  useEffect(() => {
    if (!isPlaying) return
    soundRef.current.volume = volume
  }, [volume, isPlaying])

  return (
    <div>
      <div className="frow items-center">
        <div className="fcol items-center">
          <div
            className="btn btn-primary flex-1 btn-block attach-bottom"
            onClick={onDown}
          >
            <i className="ph ph-minus" /> 1
          </div>
          <div className="btn btn-primary flex-1 btn-block" onClick={on10Down}>
            <i className="ph ph-minus" /> 10
          </div>
        </div>
        <div
          className="flex-3 digital-display-wrapper digital-display-wrapper-big frow items-center justify-center"
          onClick={toogleIsPlaying}
        >
          <div
            className={clsx('digital-display', {
              'digital-display-disabled': !isPlaying
            })}
          >
            {bpm}
          </div>
          <i
            className={clsx('ph text-sm text-5xl', {
              'ph-play text-gray-500': !isPlaying,
              'ph-stop text-green-500': isPlaying
            })}
          />
        </div>
        <div className="fcol items-center">
          <div
            className="btn btn-primary flex-1 btn-block attach-bottom"
            onClick={onUp}
          >
            <i className="ph ph-plus" /> 1
          </div>
          <div className="btn btn-primary flex-1 btn-block" onClick={on10Up}>
            <i className="ph ph-plus" /> 10
          </div>
        </div>
      </div>
      <div className="frow items-center gap-3 px-4">
        <i className="ph ph-speaker-low text-white" />
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={volume}
          onChange={onVolumeChange}
          className="flex-1"
          style={{
            accentColor: '#fff'
          }}
        />
        <i className="ph ph-speaker-high text-white" />
        <span className="text-xs text-white min-w-[40px]">
          {Math.round(volume * 100)}%
        </span>
      </div>
    </div>
  )
}

export default Metronome
